import React from 'react';

const ContainerBG = ({ styles, ...props }) => {
  const { children } = props;
  return <div className={`container-bg ${styles} `}>{children}</div>;
};

export default ContainerBG;
